// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import store from "./store"
import axios from 'axios'
//请求的基础的url
const production_url = 'https://cnend.leadscloud.com';
// const production_url = 'http://test.leadscloud.com/';
axios.defaults.baseURL = production_url;
axios.defaults.timeout = 30000;
axios.defaults.headers = {
  'Content-Type': 'application/json; charset=UTF-8'
};
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;
Vue.config.productionTip = false;
Vue.use(iView);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js